import React from "react";

import { AlignVAT } from "@vp/ep-pricing";
import { useSwanStyleKeys } from "@vp/ubik-context";
import { SWAN_STYLE_KEYS } from "../../constants/swanStyleKeys";
import { useSafeUserContext } from "../../hooks/useSafeUserContext";
import { LocalizationsProvider } from "../../hooks/useLocalizations";
import { getLocalizationsFor } from "../../localization/getLocalizations";
import { productPricingService } from "../../services/productPricingService";
import { useProductStore } from "../../store/productPriceDetails.store";
import { ProductPricingInput } from "../../types/pricing/price-display.types";
import PriceErrorBoundary from "../PriceErrorBoundary";
import { PriceExtractionWrapper } from "./PriceExtractionWrapper";

// 1. Accept details like mpvId, requestor, displayStrategy, selections (optionally), quantity (optionally) or quantityEnum (optionally),
// 2. Pass the details to VistaPriceExtractionWrapper

export interface PriceDisplayV2Props extends ProductPricingInput {
  alignVAT?: AlignVAT;
  isTile?: boolean;
  developmentMode?: boolean;
  /** Override locale for integrations where Ubik context is not available */
  locale?: string;
  /** Override tenant for integrations where Ubik context is not available */
  tenant?: string;
  /**
   * When `true`, renders only the Logo Processing Charge or nothing.
   * Prevents fallthrough to normal pricing when neither docRefUrl nor
   * assumeDocRequiresCertification is set.
   */
  showLogoChargeOnly?: boolean;
}

const PriceDisplayV2 = (props: PriceDisplayV2Props) => {
  const basePriceExtractionConfig = useProductStore((state) => state.basePriceExtractionConfig);

  const userContext = useSafeUserContext();
  const locale = props.locale ?? userContext?.locale ?? basePriceExtractionConfig?.locale;
  const tenant = props.tenant ?? userContext?.tenant ?? basePriceExtractionConfig?.tenant ?? "vistaprint";

  if (!locale) return null;

  productPricingService.locale = locale;
  productPricingService.tenant = tenant;

  const localizations = getLocalizationsFor(locale);

  useSwanStyleKeys(SWAN_STYLE_KEYS);

  return (
    <LocalizationsProvider localizations={localizations}>
      <PriceErrorBoundary fallbackUi={<></>}>
        <PriceExtractionWrapper {...props} />
      </PriceErrorBoundary>
    </LocalizationsProvider>

  );
};

export { PriceDisplayV2 };
